import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import MainRoutes from './Routes'
import React, { useEffect, useState } from 'react';
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import './App.css';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from './env.json';
export let sqlite: any;
export let existingConn: any;


type AppProps = {
  pca: IPublicClientApplication
};



function App({ pca }: AppProps) {

  document.documentElement.style.setProperty('--primary-color', `${config.REACT_APP_MAIN_APP_CSS_PRIMARY_COLOR}`);
  document.documentElement.style.setProperty('--secondary-color', `${config.REACT_APP_MAIN_APP_CSS_SECONDARY_COLOR}`);
  document.documentElement.style.setProperty('--tertiary-color', `${config.REACT_APP_MAIN_APP_CSS_TERTIARY_COLOR}`);
  document.documentElement.style.setProperty('--primary-text-color', `${config.REACT_APP_MAIN_APP_CSS_PRIMARY_TEXT_COLOR}`);
  document.documentElement.style.setProperty('--secondary-text-color', `${config.REACT_APP_MAIN_APP_CSS_SECONDARY_TEXT_COLOR}`);
  document.documentElement.style.setProperty('--placeholder-text-color', `${config.REACT_APP_MAIN_APP_CSS_PLACEHOLDER_TEXT_COLOR}`);





  return (
    <>
      <MsalProvider instance={pca}>
        <MainRoutes/>
      </MsalProvider> 
    </>
  );
}

export default App;
